import { SmartTable } from '../../../../components/smart-table/smart-table.model';
export class Controller {

	/** @ngInject */
	constructor($state, Alert, SharedAccountsService, CompanyUser) {
		this.$state = $state;
		this.Alert = Alert;
		this.SharedAccountsService = SharedAccountsService;
		this.CompanyUser = CompanyUser;
	}

	$onInit() {
		if (this.selectedAccounts == null || this.selectedAccounts.length == 0) {
			this.close();
		}
		this.labels$.get().then((labels) => this.labels = labels);
		this.isAuthenticator = this.$state.current.name == 'company.sharing-center.shared-authenticators.manage-bulk';
		this.st = new SmartTable(); 
		this.st.displayedItems=this.selectedAccounts;
		this.selectedLabels = [];
		this.selectedUnshareLabels = [];
		this.showPasswordEnabled = false;
		this.showOtpEnabled = false;
		this.showNoteEnabled = false;
		this.companyUsers = [];
		this.newUserIdentifier = null;
		this.userIdentifier = null;

	}
	
	
	isCheckedLabel(label) {
		var indexOfLabel = this.selectedLabels.indexOf(label);
		return indexOfLabel >= 0;
	}
	
	isCheckedUnshareLabel(label) {
		var indexOfLabel = this.selectedUnshareLabels.indexOf(label);
		return indexOfLabel >= 0;
	}

	isCheckboxDisabled(label) {
		var isIt = (label.name !== "ALL_USERS") && (this.selectedLabels.length == 1) && (this.selectedLabels[0].name === "ALL_USERS");
		var isLabelInUnshare = this.selectedUnshareLabels.length && ((this.selectedUnshareLabels[0].name === "ALL_USERS") || (this.selectedUnshareLabels.indexOf(label)>=0) );
		var isAllLabelBlocked=(label.name === "ALL_USERS") && this.selectedUnshareLabels.length;
		return isIt || isLabelInUnshare || isAllLabelBlocked;
	}
	
	isCheckboxUnshareDisabled(label) {
		var isIt = (label.name !== "ALL_USERS") && (this.selectedUnshareLabels.length == 1) && (this.selectedUnshareLabels[0].name === "ALL_USERS");
		var isLabelInShare = this.selectedLabels.length && ((this.selectedLabels[0].name === "ALL_USERS") || (this.selectedLabels.indexOf(label)>=0) )
		var isAllLabelBlocked=(label.name === "ALL_USERS") && this.selectedLabels.length;
		return isIt || isLabelInShare || isAllLabelBlocked;
	}
	
	clickLabel(label) {
		var indexOfLabel = this.selectedLabels.indexOf(label);
		if (indexOfLabel >= 0) {
			this.selectedLabels.splice(indexOfLabel, 1)
		} else {
			if (label.name === "ALL_USERS") {
				this.selectedLabels = [];
			}
			this.selectedLabels.push(label);
		}
	}
	
	clickUnshareLabel(label) {
		var indexOfLabel = this.selectedUnshareLabels.indexOf(label);
		if (indexOfLabel >= 0) {
			this.selectedUnshareLabels.splice(indexOfLabel, 1)
		} else {
			if (label.name === "ALL_USERS") {
				this.selectedUnshareLabels = [];
			}
			this.selectedUnshareLabels.push(label);
		}
	}
	
	clearSearch() {
		this.successResult = false;
		this.companyUser=null;
		this.newUserIdentifier=null;
		this.userIdentifier=null;
		this.showClear=false;
	}
	
	
	identifyUser() {
		this.successResult = false;
		this.companyUser = null;
		this.message = null;
		this.userIdentifier = this.newUserIdentifier;
		this.CompanyUser.identifyCompanyUser({
			companyId: this.companyId,
			uid: encodeURIComponent(this.userIdentifier)
		}).$promise
			.then((response) => {
				this.companyUser = response;
				this.companyUser.selected = true;
				this.companyUsers.push(this.companyUser);
				this.message = 'groups_users.user_found';
				this.successResult = true;
			})
			.catch((error) => { 
				console.log(error); 
				if (error.status == 404) {
                                this.message = 'groups_users.user_not_found';
                            } else {
                                this.message = error.message;
                            }
			})
			.finally(()=>{this.showClear=true;});
	}

	getSelectedSaaspassUsersIds() {
		return this.companyUsers.filter((user) => user.selected).map((user) => user.saaspassUser.id);
	}

	checkboxChange(cUser) {
		var foundIndex = this.companyUsers.findIndex(x => x.id == cUser.id);
		this.companyUsers[foundIndex].selected = (!cUser.selected);
	}
	
	
	save() {
		var saaspassUsersIds = this.getSelectedSaaspassUsersIds();
		
		let selectedAccountsIds= this.selectedAccounts.map((item) => item.id);
		
			this.SharedAccountsService.updateAndShareServiceAccountsWithLabels({
				companyId: this.companyId,
				showPassword: this.showPasswordEnabled,
				showOtp: this.showOtpEnabled,
				showNote: this.showNoteEnabled
				
				
			}, { labels: this.selectedLabels, labelsToUnshare:this.selectedUnshareLabels,corporateServiceAccountIds: selectedAccountsIds, spUsersIds: saaspassUsersIds })
				.$promise
				.then(() => {
					this.close();
					this.Alert('success', 'company.sharing-center.shared-authenticators.bulk-manage.save-succes')

				})
				.catch(error => {
					console.log(error);
					//this.Alert('danger', error.message);
				});
		

	}
	close() {
		this.$state.go('^', {}, { reload: true });
	}
	cancel() {
		this.$state.go('^');
	}
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/manage-bulk/manage-bulk.controller.js